import _defineProperty from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React, { useContext } from 'react';
import { css } from 'styled-components';
import { screenMdMax } from '@spotify-internal/encore-web';
import { jsx as _jsx } from "react/jsx-runtime";
var DURATION = '500ms';
/*
For our current animations we want certain text inside our modules to animate
before or after certain other text. To accomplish this we added a constant
that maps an order descriptor (FIRST, SECOND, etc.) to the number of milliseconds
to delay by. This allows the user to have an easier time reading the code and
understanding what is happening. Delays are typically set to be 250ms apart. This
can be customized if needed by passing a value other than DELAYS.X
*/

export var DELAYS = {
  FIRST: 0,
  SECOND: 250,
  THIRD: 500,
  FOURTH: 750,
  FIFTH: 1000,
  SIXTH: 1250,
  SEVENTH: 1500,
  EIGHTH: 1750,
  NINTH: 2000,
  TENTH: 2250
};
export var Crossfade = css(["opacity:", ";z-index:", ";transition:opacity 0.75s linear,z-index 0s 0.75s,color 0s 0.75s;"], function (_ref) {
  var active = _ref.active;
  return active ? 1 : 0;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? 1 : 'unset';
});

/*
The current list of customized thresholds for the customThreshold function below
 */
var customThresholds = {
  featuredContent2Up: 0.4,
  featuredContent3Up: 0.4,
  groupTestimonial: 0.6,
  editorialGrid: 0.6,
  relatedLinksModule: 0.5,
  singleTestimonial: 0.6
};
/*
We have some modules that are larger vertically than others. Due to the way some of these are
layed out we have a large amount of space at the top for an image. The way that intersection
observer works is to say something is on screen once the "threshold" has been met. For example,
a threshold of .4 means to return true that the module is on the screen once it's scrolled no less
than 40 of the module on the screen. We use this to allow us to only trigger animations once the
animatable text is on the screen not just the module itself. We have a default of .25 set.
 */

export var customThreshold = function customThreshold(contentType) {
  if (contentType in customThresholds) {
    return customThresholds[contentType];
  }

  return 0.25;
};
/*
Very simple function that returns the css template to enable a fade in effect. Opacity starts at 0
and goes to 1.
 */

var applyKeyframes = css(["@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}"]);
/*
This function is called when it has been determined that a given module needs to animate. This
sets the text areas to opacity 0 but only if the module is on screen, animatable, and has not yet
animated.
 */

var applyStartState = function applyStartState(props) {
  var _props$animationConte, _props$animationConte2, _props$animationConte3;

  return !((_props$animationConte = props.animationContext) !== null && _props$animationConte !== void 0 && _props$animationConte.isOnScreen) && (_props$animationConte2 = props.animationContext) !== null && _props$animationConte2 !== void 0 && _props$animationConte2.moduleAnimatable && ((_props$animationConte3 = props.animationContext) === null || _props$animationConte3 === void 0 ? void 0 : _props$animationConte3.hasAnimated) < 1 ? "opacity: 0;" : '';
};
/*
This is the function that returns the css that actually sets up the animation duration and custom
delays.
 */


var applyAnimation = function applyAnimation(delay, props) {
  var _props$animationConte4, _props$animationConte5, _props$animationConte6;

  return (_props$animationConte4 = props.animationContext) !== null && _props$animationConte4 !== void 0 && _props$animationConte4.isOnScreen && (_props$animationConte5 = props.animationContext) !== null && _props$animationConte5 !== void 0 && _props$animationConte5.moduleAnimatable && ((_props$animationConte6 = props.animationContext) === null || _props$animationConte6 === void 0 ? void 0 : _props$animationConte6.hasAnimated) < 2 ? "animation: ".concat(DURATION, " linear ").concat(delay, "ms 1 both fadeIn;") : '';
};
/*
get animation text for staggered text animations in modules
The hook uses IntersectionObserver to determine if a given ref (attached to the module) is on the
screen and takes into consideration the custom thresholds.
 */


function useOnScreen(ref) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0px';
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.25;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isIntersecting = _React$useState2[0],
      setIntersecting = _React$useState2[1];

  React.useEffect(function () {
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            entry = _ref4[0];

        setIntersecting(entry.isIntersecting);
      }, {
        rootMargin: rootMargin,
        threshold: threshold
      });

      if (ref !== null && ref !== void 0 && ref.current) {
        observer.observe(ref.current);
      }

      return function () {
        if (ref !== null && ref !== void 0 && ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }

    return function () {};
  }, []);
  return isIntersecting;
}

/*
This is a React Context object that we use to hold the values that are referenced in applyStartState
and applyAnimation. As long as the context is sent to the module as a prop and passed as a prop to
the styled component we are able to use the animations functions and tie all of our animations bits
together.
 */
export var AnimationContext = /*#__PURE__*/React.createContext({
  isOnScreen: false,
  moduleAnimatable: false,
  hasAnimated: 0
});
/*
This hook is what sets up the animationContext and ref for use by the modules. It creates the ref
needed to enable the useOnScreen hook, creates the isOnScreen const that tells us when the ref
is on the screen, and checks whether the module should animate and if it's in the list of animatable
modules.
 */

export function useAnimations(contentType, shouldAnimate, threshold) {
  var animationRef = /*#__PURE__*/React.createRef();

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasAnimated = _React$useState4[0],
      setHasAnimated = _React$useState4[1];

  var isOnScreen = useOnScreen(animationRef, '0px', threshold);
  var moduleAnimatable = shouldAnimate && isAnimatable(contentType);
  React.useEffect(function () {
    if (isOnScreen) {
      setHasAnimated(hasAnimated + 1);
    }
  }, [isOnScreen]);
  var animationContext = {
    isOnScreen: isOnScreen,
    moduleAnimatable: moduleAnimatable,
    hasAnimated: hasAnimated
  };
  return {
    animationContext: animationContext,
    animationRef: animationRef
  };
}
/*
This function uses apply* functions to set up the actual media query that will be attached to
the proper module text areas/components.
 */

export function fadeInAnimation(delay) {
  return css(["@media (min-width:", "){", ";", ";", ";}"], screenMdMax, applyKeyframes, function (props) {
    return applyStartState(props);
  }, function (props) {
    return applyAnimation(delay, props);
  });
}
/*
This takes any React or Styled Component and attaches the animation context.
 */

export function withAnimationContext(Component) {
  return function (props) {
    var animationContext = useContext(AnimationContext);
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      animationContext: animationContext
    }));
  };
}
/*
This is the source of truth for what modules will animate. It is used as a check to prevent
animations from accidentally showing up on non-animatable modules.
 */

var isAnimatable = function isAnimatable(mod) {
  return ['editorialGridModule', 'heroBodyModule', 'headerModule', 'heroBodyCarousel', 'heroHeaderCarousel', 'heroNarrativeCarousel', 'faqLinksModule', 'groupTestimonial', 'heroCaseStudyCover', 'singleTestimonial', 'singleFeatureModule', 'pageBreakerModule', 'featuredContent2Up', 'featuredContent3up', 'featuredContentModule', 'relatedLinksModule'].includes(mod);
};